import SuperJSON from "superjson";
import Id from "../types/Id";

export default class FormVersionId extends Id<"formVersion"> {}

SuperJSON.registerClass(FormVersionId);
